// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1h2kJ","footer":"styles_footer__T5JTu","passCodeTooltip":"styles_passCodeTooltip__2uzcM"};